export default {"src":"/_next/static/media/purple-arrow-down-left.bc1d1b99.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};